import type { ReactNode } from 'react';
import { Container, SectionHeader, Stack, Surface } from '../ui';

export interface TemplateEditorDocumentProps {
  title: string;
  description?: string | undefined;
  notices?: ReactNode;
  children: ReactNode;
}

/**
 * Bounded paper surface used by the template canvas. The surrounding studio
 * may be fluid; authored content keeps one readable measure and one surface
 * hierarchy at every desktop width.
 */
export function TemplateEditorDocument({
  title,
  description,
  notices,
  children,
}: TemplateEditorDocumentProps): JSX.Element {
  return (
    <Container width="reading" data-testid="template-editor-document">
      <Stack gap={3}>
        {notices}
        <Surface as="article" variant="flat" padding="xl" className="min-h-full">
          <Stack gap={6}>
            <SectionHeader
              title={title || 'Untitled inspection template'}
              description={description || 'Add a description to explain what this template covers and when to use it.'}
            />
            {children}
          </Stack>
        </Surface>
      </Stack>
    </Container>
  );
}
